import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormCustomMessage: FC = () => {
  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.customMessage.title" />
      </Heading>
      <MarketplacePartnerRegisterPageFormInputField
        fieldName="message"
        label={
          <FormattedMessage id="marketplacePartnerRegisterPage.customMessage.label" />
        }
        type="textarea"
      />
    </div>
  )
}
